var _a;
import config from "~/config";
export const rollbarConfig = {
    accessToken: config.ROLLBAR_ACCESS_TOKEN,
    captureUncaught: true,
    captureUnhandledRejections: true,
    enabled: config.ROLLBAR_ACCESS_TOKEN !== undefined,
    payload: {
        environment: config.ENVIRONMENT,
        client: {
            javascript: {
                source_map_enabled: true,
                code_version: config.ENVIRONMENT === "production"
                    ? ((_a = config.GITHUB_COMMIT_SHA) !== null && _a !== void 0 ? _a : undefined)
                    : undefined,
            },
        },
    },
};
